import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import {
  BASE_URL,
  MARKETING_FETCH,
  UPDATE_FEATURE,
  UPDATE_FEATURE_MASCOT,
  UPDATE_AGENT_MASCOT,
  UPDATE_FEATURE_ANGPOW,
  M_POST,
  M_GET
} from '@/utils/api';

@Module({ name: 'marketing' })
export default class Marketing extends VuexModule {
  @Action({ rawError: true })
  async Fetch() {
    try {
      const { data } = await axios({
        url: BASE_URL + MARKETING_FETCH,
        method: M_GET
      });

      assertOk(data, 'Fetch marketing failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch marketing failed');
    }
  }

  @Action({ rawError: true })
  async FeatureUpdate(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPDATE_FEATURE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update feature failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Update feature failed');
    }
  }

  @Action({ rawError: true })
  async FeatureMascotUpdate(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPDATE_FEATURE_MASCOT,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update feature mascot failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Update feature mascot failed');
    }
  }

  @Action({ rawError: true })
  async AgentMascotUpdate(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPDATE_AGENT_MASCOT,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update agent mascot failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Update agent mascot failed');
    }
  }

  @Action({ rawError: true })
  async FeatureAngpowUpdate(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPDATE_FEATURE_ANGPOW,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update feature angpow failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Update feature angpow failed');
    }
  }
}
